






















































































































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class NavigationTabs extends Vue {
  @Prop() readonly customerId!: string;

  private isActiveTab(tab: string): boolean {
    return this.$route.name == tab;
  }
}
